import INVOICE from './invoice.gql';

export default INVOICE;
export { INVOICE };
